import React, { useEffect, useRef } from 'react';
import Modal from './Modal';
import Button from '../Button/Button';
import InputTextArea from '../Input/InputTextArea';
import { theme } from '../../theme';
import styled from 'styled-components';
import Typography from '../Typography';
import { useTranslation } from 'react-i18next';

const CreateEventDescriptionModal = ({ description, onChange, error, onClose }) => {
  const { t } = useTranslation('createEvent');
  const textAreaRef = useRef(null);

  useEffect(() => {
    // Enfocar el textarea cuando el componente se monta
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, []);

  return (
    <Modal onClose={onClose} title={t('createEventDescriptionModal.title', { ns: 'createEvent' })} closeOnOverlayClick={false}>
      <ModalContent>
        {/* <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultWeak}>
          {t('createEventDescriptionModal.description')}
        </Typography> */}
        <DescriptionArea
          ref={textAreaRef}
          size="large"
          name="description"
          value={description}
          onChange={onChange}
          placeholder={t('createEventDescriptionModal.descriptionPlaceholder', { ns: 'createEvent' })}
          $variant={error ? 'error' : ''}
          required
        />
        {error &&
          <ErrorMessage>
            <Typography as="p" $variant="body-2-medium" color={theme.colors.errorMain}>
              {error}
            </Typography>
          </ErrorMessage>
        }
      </ModalContent>
      <FormActions>
        <Button size="l" sizeTablet="l" sizeMobile="m" onClick={onClose}>
          {t('createEventDescriptionModal.save')}
        </Button>
      </FormActions>
    </Modal>
  );
};

export default CreateEventDescriptionModal;

const ModalContent = styled.div`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border-radius: ${({ theme }) => theme.radius.sm};
  display: flex;
  flex-direction: column;
  // gap: ${({ theme }) => theme.sizing.md};
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100%;
  }
`;

const DescriptionArea = styled(InputTextArea)`
  field-sizing: content;
  padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.sm};
  resize: none;
  width: 100%;
  min-height: 200px;
  background-color: ${({ theme }) => theme.fill.defaultSubtle};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100%;
  }
`;

const FormActions = styled.div`
  border-top: 1px solid ${({ theme }) => theme.border.defaultWeak};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  text-align: center;
  width: 100%;
`;

const ErrorMessage = styled.div`
  display: flex;
  padding-top: ${({ theme }) => theme.sizing.xs};
`;
